import { render } from "./CookieNotice.vue?vue&type=template&id=2db62ffe&scoped=true"
import script from "./CookieNotice.vue?vue&type=script&lang=js"
export * from "./CookieNotice.vue?vue&type=script&lang=js"

import "./CookieNotice.vue?vue&type=style&index=0&id=2db62ffe&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db62ffe"]])

export default __exports__